import { reduce } from '../helpers/utils';

const debug = require('debug')('jp:stores:locations');

const LOAD = 'locations/LOAD';
const LOAD_SUCCESS = 'locations/LOAD_SUCCESS';
const LOAD_FAIL = 'locations/LOAD_FAIL';

const initialState = {
  loaded: false,
  loading: false,
  error: false,
  location: null,
  reviews: []
};

export default reduce(initialState, {
  [LOAD](state) {
    debug(LOAD);
    return { ...state, loading: !state.loading };
  },
  [LOAD_SUCCESS](state, action) {
    debug(LOAD_SUCCESS, action.payload.data);
    return {
      ...state,
      reviews: action.payload.data.reviews.data,
      location: action.payload.data,
      loading: !state.loading,
      loaded: !state.loaded,
      error: false
    };
  },
  [LOAD_FAIL](state) {
    debug(LOAD_FAIL);
    return {
      ...state,
      loading: !state.loading,
      error: true
    };
  }
});

export function load(slug, locale) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: client => client.geo.getLocation(slug, locale)
  };
}
